import { ReactNode, useEffect, useState } from 'react';
import { useGetCompanyByIdQuery, useUpdateCompanyByIdMutation } from '../../API/authApi';
import { useExprationHook, useGeneralHooks, useToastify } from '../../Hooks/hooks';
import { BusinessTypes } from '../../Interfaces/componentTypes';
import RestaurantPage from '../Business/Restaurant/restaurantPage';
import CafePage from '../Business/cafePage';
import PizzeriaPage from '../Business/pizzeriaPage';
import HotelPage from '../Business/HotelPage';
import FastFoodPage from '../Business/FastFoodPage';
import CofeShopPage from '../Business/cofeShopPage';
import { ICompanyResponse } from '../../Interfaces/responseTypes';
import Loading from '../../Components/Loading/loading';
import ShopPage from '../Business/shopPage';
import styles from './myBusiness.module.scss';

export interface IMyBusinessProps {
    data: ICompanyResponse,
    onCompanyUpdate: () => void
}

const useMyBusinessHook = (id: number) => {
    const { data: businessData, isLoading, isSuccess, isError, refetch } = useGetCompanyByIdQuery({ id: id });
    const [update, { data: updatedData, isSuccess: isUpdated, isError: isUpdateError }] = useUpdateCompanyByIdMutation();
    const { showToastError } = useToastify();
    const { navigate } = useGeneralHooks();
    const type = (businessData as ICompanyResponse)?.type;
    const [renderLoading, setRenderLoading] = useState<boolean>(false);
    const [templateId, setTemplateId] = useState<number | null>(null);
    const loading = isLoading || renderLoading || !type || !templateId;
    const { demoStatus, paidStatus } = useExprationHook(businessData!);
    useEffect(() => {
        if (isUpdateError) {
            showToastError('Something went wrong')
        }
    }, [isUpdateError]);

    useEffect(() => {
        if (isSuccess && businessData) {
            if ((demoStatus && demoStatus === 'expired') || (paidStatus && paidStatus === 'expired')) {
                navigate(`/home`);
            }

            if (!businessData.autor_id) {
                navigate(`/${businessData.name}/menu/${businessData.id}`);

            }
            localStorage.setItem(`p_m_template`, `2`);
            setTemplateId(2);
        }
    }, [isSuccess, businessData, demoStatus, paidStatus]);

    useEffect(() => {
        if (isUpdated && updatedData) {
            localStorage.setItem(`p_m_template`, `${updatedData.template_id}`);
            setTemplateId(updatedData.template_id)
        }
        isUpdated && updatedData && setTemplateId(updatedData.template_id)
    }, [isUpdated, updatedData]);

    const onCompanyUpdate = () => {
        refetch()
    };

    const props: IMyBusinessProps = {
        data: businessData!,
        onCompanyUpdate: onCompanyUpdate
    };

    const renderPage = (type: BusinessTypes | undefined): ReactNode => {
        switch (type) {
            case BusinessTypes.RESTAURANT:
                return <RestaurantPage {...props} />;
            case BusinessTypes.CAFE:
                return <CafePage {...props} />;
            case BusinessTypes.PIZZERIA:
                return <PizzeriaPage {...props} />;
            case BusinessTypes.HOTEL:
                return <HotelPage {...props} />;
            case BusinessTypes.FAST_FOOD:
                return <FastFoodPage {...props} />;
            case BusinessTypes.COFFEE_SHOP:
                return <CofeShopPage {...props} />;
            case BusinessTypes.SHOP:
                return <ShopPage {...props} />;
            default:
                return (
                    <div className={styles.lodingContainer}>
                        <Loading />
                    </div>
                )
        }
    };

    return {
        type,
        loading,
        isError,
        renderPage,
        businessData,
    };
};

export default useMyBusinessHook;
